(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("browser-cookies"), require("lodash/cloneDeep"), require("lodash/merge"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["browser-cookies", "lodash/cloneDeep", "lodash/merge", "axios"], factory);
	else if(typeof exports === 'object')
		exports["libGetService"] = factory(require("browser-cookies"), require("lodash/cloneDeep"), require("lodash/merge"), require("axios"));
	else
		root["libGetService"] = factory(root["browser-cookies"], root["_"]["cloneDeep"], root["_"]["merge"], root["axios"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__422__, __WEBPACK_EXTERNAL_MODULE__735__, __WEBPACK_EXTERNAL_MODULE__941__, __WEBPACK_EXTERNAL_MODULE__674__) => {
return 